import React, { ReactElement } from 'react';
import { Layout, Menu } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const { Sider, Content, Header } = Layout;

const items = [
    { key: '/admin/users', label: 'Участники' },
    { key: '/admin/users/bulk', label: 'Массовая загрузка' },
    { key: '/admin/ticket', label: 'Билет' },
    { key: '/admin/votes', label: 'Голосование' },
    { key: '/admin/settings', label: 'Настройки' },
];

export default function AdminLayout(): ReactElement {
    const navigate = useNavigate();
    const location = useLocation();
    const selected =
        items.find(i => location.pathname.startsWith(i.key))?.key ??
        '/admin/users';

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider width={240} theme="light">
                <div
                    style={{
                        padding: 16,
                        fontWeight: 600,
                        fontSize: 18,
                    }}
                >
                    Админка
                </div>
                <Menu
                    mode="inline"
                    selectedKeys={[selected]}
                    items={items}
                    onClick={({ key }): void => navigate(key)}
                />
            </Sider>
            <Layout>
                <Header style={{ background: '#fff', padding: '0 24px' }}>
                    <button
                        type="button"
                        onClick={(): void => {
                            localStorage.removeItem('token');
                            navigate('/login');
                        }}
                        style={{
                            float: 'right',
                            marginTop: 16,
                            border: 'none',
                            background: 'transparent',
                            cursor: 'pointer',
                        }}
                    >
                        Выйти
                    </button>
                </Header>
                <Content style={{ padding: 24 }}>
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
}
